import React from 'react';
import { Icon } from '../icons';
import { useT } from '../../i18n';

/**
 * NumberStepper — quantity input with − / + buttons (nights, guests, POS qty).
 *
 * Props:
 *   value: number, onChange(next)
 *   min, max, step (default 1)
 *   size: 'sm' | 'md'
 *   disabled
 *   ariaLabel
 */
const NumberStepper = ({
  value = 0,
  onChange,
  min = -Infinity,
  max = Infinity,
  step = 1,
  size = 'md',
  disabled = false,
  ariaLabel,
  className = '',
}) => {
  const t = useT();
  const set = (next) => {
    const clamped = Math.min(max, Math.max(min, next));
    if (clamped !== value) onChange?.(clamped);
  };

  return (
    <div className={`ps-stepper ps-stepper--${size}${disabled ? ' is-disabled' : ''} ${className}`.trim()}>
      <button
        type="button"
        className="ps-stepper__btn"
        aria-label={t('Decrease')}
        disabled={disabled || value <= min}
        onClick={() => set(value - step)}
      >
        <Icon.Minus size={16} />
      </button>
      <input
        type="text"
        inputMode="numeric"
        className="ps-stepper__input"
        aria-label={ariaLabel ?? t('Quantity')}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const n = Number(e.target.value.replace(/[^0-9.-]/g, ''));
          if (!Number.isNaN(n)) set(n);
        }}
      />
      <button
        type="button"
        className="ps-stepper__btn"
        aria-label={t('Increase')}
        disabled={disabled || value >= max}
        onClick={() => set(value + step)}
      >
        <Icon.Plus size={16} />
      </button>
    </div>
  );
};

export default NumberStepper;
